import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material'

type Props = {
    message?: string
    onClose(): void
    open: boolean
    title: string | null
}

const DEFAULT_MESSAGE =
    'Please reach out to the development team and we can' +
    ' investigate the issue.'

const DownloadErrorDialog = (props: Props) => {
    return (
        <Dialog onClose={props.onClose} open={props.open}>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message ?? DEFAULT_MESSAGE}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Dismiss
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DownloadErrorDialog
